import { render, staticRenderFns } from "./CtaFour.vue?vue&type=template&id=9bf90980&"
import script from "./CtaFour.vue?vue&type=script&lang=js&"
export * from "./CtaFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports